export function splUiGradient(seed: string = crypto.randomUUID()): string {
  // Simple hash function to generate a number from the seed
  const hash = seed.split('').reduce((acc, char) => {
    return (acc << 5) - acc + char.charCodeAt(0);
  }, 0);

  // Generate two pastel colors from the hash
  const hue1 = Math.abs(hash) % 360;
  const hue2 = (hue1 + 137) % 360; // Golden angle for pleasant color combinations

  const saturation = 50 + (Math.abs(hash >> 8) % 15); // 50-65% (balanced pastel)
  const lightness = 70 + (Math.abs(hash >> 16) % 10); // 70-80% (balanced brightness)

  const color1 = `hsl(${hue1}, ${saturation}%, ${lightness}%)`;
  const color2 = `hsl(${hue2}, ${saturation}%, ${lightness - 3}%)`;

  return `linear-gradient(135deg, ${color1}, ${color2})`;
}
